import { render, staticRenderFns } from "./DashFeesRate.vue?vue&type=template&id=f209095c&scoped=true&"
import script from "./DashFeesRate.vue?vue&type=script&lang=js&"
export * from "./DashFeesRate.vue?vue&type=script&lang=js&"
import style0 from "./DashFeesRate.vue?vue&type=style&index=0&id=f209095c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f209095c",
  null
  
)

export default component.exports